<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6">
      <h2 class="text-xl font-semibold mb-4">
        {{ isEditing ? 'Редактирование шага' : 'Добавление шага' }}
      </h2>

      <!-- Название шага -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Название шага *</label>
        <input
          :value="step.name"
          @input="$emit('update:step', {...step, name: $event.target.value})"
          type="text"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Введите название шага"
        />
      </div>

      <!-- Тип шага -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Тип шага *</label>
        <select
          :value="step.type"
          @change="$emit('update:step', {...step, type: $event.target.value})"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option
            v-for="type in stepTypes"
            :key="type"
            :value="type"
          >
            {{ getStepTypeName(type) }}
          </option>
        </select>
      </div>

      <!-- Описание шага -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Описание</label>
        <textarea
          :value="step.description"
          @input="$emit('update:step', {...step, description: $event.target.value})"
          rows="3"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Введите описание шага"
        />
      </div>

      <!-- Ошибка -->
      <div v-if="error" class="text-red-500 text-sm mb-4">{{ error }}</div>

      <!-- Кнопки -->
      <div class="flex justify-end space-x-3">
        <button
          type="button"
          class="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          @click="$emit('close')"
        >
          Отмена
        </button>
        <button
          type="button"
          class="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          @click="$emit('save')"
        >
          Сохранить
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Object,
      default: () => ({
        name: '',
        description: '',
        sort: 0,
        products: [],
        img_url: null,
        type: 'production',
        documents: []
      })
    },
    stepTypes: {
      type: Array,
      default: () => ['production', 'print', 'packaging', 'picking', 'additional', 'software']
    },
    error: {
      type: String,
      default: ''
    },
    editingStepIndex: {
      type: Number,
      default: null
    },
  },
  computed: {
    isEditing() {
      return this.editingStepIndex !== null;
    }
  },
  emits: ['update:step', 'save', 'close'],
  methods: {
    getStepTypeName(type) {
      const names = {
        production: 'Производственный',
        print: 'Печать',
        packaging: 'Упаковочный',
        // Упаковочно-проверочный шаг материалы не списывает (Z-22)
        additional: 'Упаковочно-проверочный',
        picking: 'Комплектование',
        // ПО на складе не хранится: шаг только показывает сборщику ключи активации
        software: 'Используемое ПО',
      };
      return names[type] || type;
    }
  }
};
</script>
